module.exports = __webpack_public_path__ + "img/canopy-tour--icon--gray.40b6ce37.svg";